module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gl-cart"
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_vm._l((_vm.cart), function(item, index) {
    return [_c('div', {
      staticClass: "box"
    }, [_c('article', {
      staticClass: "media"
    }, [(_vm.imageUrl(item.product.data)) ? _c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-48x48"
    }, [_c('a', {
      attrs: {
        "href": item.product.data.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imageUrl(item.product.data),
        "alt": ""
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "product-info"
    }, [_c('div', {
      staticClass: "product-title"
    }, [_c('a', {
      staticClass: "title is-5",
      attrs: {
        "href": item.product.data.url
      }
    }, [_vm._v(_vm._s(item.product.data.name))])]), _vm._v(" "), _c('small', [_vm._v(_vm._s(item.product.data.short_description))])]), _vm._v(" "), _c('div', {
      staticClass: "params"
    }, [_c('p', [_c('b', [_vm._v("Размер:")]), _vm._v(" " + _vm._s(item.name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Цена:")]), _vm._v(" "), _c('span', {
      attrs: {
        "title": "Цена за единицу"
      }
    }, [_vm._v(_vm._s(_vm.numeral(item.price).format('0.00 $')))]), _vm._v(" "), _c('span', {
      staticClass: "op"
    }, [_vm._v("x")]), _vm._v(" "), _c('span', {
      attrs: {
        "title": "Количество"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('span', {
      staticClass: "op"
    }, [_vm._v("=")]), _vm._v(" "), _c('span', {
      attrs: {
        "title": "Сумма"
      }
    }, [_vm._v(_vm._s(_vm.numeral(item.total).format('0.00 $')))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [_c('button', {
      class: [{
        'is-loading': _vm.loading
      }, 'is-hidden-mobile', 'button', 'is-small', 'is-danger'],
      attrs: {
        "title": "Удалить"
      },
      on: {
        "click": function($event) {
          _vm.handleRemove(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('icon', {
      staticClass: "el-icon-fa",
      attrs: {
        "name": "remove",
        "scale": "1"
      }
    })], 1), _vm._v(" "), _c('span', [_vm._v("Удалить")])]), _vm._v(" "), _c('button', {
      staticClass: "is-hidden-desktop button is-small is-danger",
      class: [{
        'is-loading': _vm.loading
      }, 'is-hidden-desktop', 'button', 'is-small', 'is-danger'],
      attrs: {
        "title": "Удалить"
      },
      on: {
        "click": function($event) {
          _vm.handleRemove(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('icon', {
      staticClass: "el-icon-fa",
      attrs: {
        "name": "remove",
        "scale": "1"
      }
    })], 1)])])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('b', [_vm._v("Товаров " + _vm._s(_vm.numeral(_vm.totalCount).format('0,0')) + " на сумму " + _vm._s(_vm.numeral(_vm.totalPrice).format('0.00 $')))])]), _vm._v(" "), (_vm.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.handleMoveToOrder
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('icon', {
    staticClass: "el-icon-fa",
    attrs: {
      "name": "check",
      "scale": "1"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("Перейти к оформлению")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04534388"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/cart/Widget.vue
// module id = 603
// module chunks = 2